/* eslint-disable no-shadow */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/explicit-length-check */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable promise/always-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
/**
	* @ngdoc service
	* @name app.Template
	* @description
	* # Template
	* Service in the app.
	*/
// eslint-disable-next-line angular/function-type
angular.module('app')
	.service('Template', /* @ngInject */ (API, $http, Notification, $rootScope, User) => ({
		export(node_kid, template_kid, output) {
			const currentUser = $rootScope.context;
			const currentToken = currentUser.token.id;

			const config = User.getAppConfig();
			console.log('config', config);
			const convertEndpoint = config.KDOC.url;

			Notification.info({
				title: 'Modèle en cours de préparation',
				message: 'Votre fichier sera bientôt disponible',
			});

			if (!output) {
				output = 'pdf';
			}

			API.exportTemplate([{
				node_kid,
				template_kid,
			}], { id: 'template-export.export' }).then(res => {
				console.log('res', res);

				const { items } = res;
				const item = items[0];
				const dataset = {};

				// For each element inside the dataset
				angular.forEach(item.dataset, (element, key) => {
					if (Object.values(element).length) {
						const object = Object.values(element);

						// If not a loop
						if (object.length === 1 && object[0].name) {
							const data = object[0];
							dataset[key] = data.name;
						}
						else {
							// If a loop
							// TODO make it recursive for deep nested values

							dataset[key] = [];

							const childsElements = [];

							// For each element inside the object [0, 1, ...]
							angular.forEach(object, objectChild => {
								// Reduce
								// {key: {name: xxx, type: yyy}}
								// to
								// {key: xxx}
								const reducedData = Object.entries(objectChild).reduce((accumulator, entries) => {
									const key = entries[0];
									const value = entries[1];

									accumulator[key] = value.name;
									return accumulator;
								}, {});

								childsElements.push(reducedData);
							});

							dataset[key] = childsElements;
						}
					}
				});

				console.log('dataset', dataset);

				$http({
					method: 'POST',
					url: `${convertEndpoint}/compile`,
					headers: {
						'content-type': 'application/json',
					},
					responseType: 'blob',
					data: {
						token: currentToken,
						kid: item.template_kid,
						type: output,
						templateData: dataset,
					},
				}).then(response => {
					const { data } = response;
					console.log('data', data);
					window.saveAs(data, `output.${output}`);
				}).catch(error => {
					console.log(error);
					Notification.error({
						message: 'Une erreur est survenue lors de la création du fichier',
					});
				});
			}).catch(error => {
				console.log(error);
				Notification.error({
					message: 'Une erreur est survenue lors de la récupération des données',
				});
			});
		},
	}));
